import { render, staticRenderFns } from "./ProductAreaPrice.vue?vue&type=template&id=5ee3c13e&scoped=true"
import script from "./ProductAreaPrice.vue?vue&type=script&lang=js"
export * from "./ProductAreaPrice.vue?vue&type=script&lang=js"
import style0 from "./ProductAreaPrice.vue?vue&type=style&index=0&id=5ee3c13e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ee3c13e",
  null
  
)

export default component.exports